import React from "react";
import { Button, Intent } from "../externals";
import { ItemStatus } from "../../entities";
import { ButtonWithDialog } from "../ButtonWithDialog";
import { GlobalHotKeys } from "react-hotkeys";
class Keys extends React.Component {
    render() {
        const keyMap = {
            A_VALIDATE: "alt+a",
            SAVE: "alt+s",
        };
        const handlers = {
            A_VALIDATE: this.props.importJob,
            SAVE: this.props.saveContent,
        };
        return React.createElement(GlobalHotKeys, { keyMap: keyMap, handlers: handlers });
    }
}
export const PythonHeader = (props) => {
    const [data, changeData] = React.useState("");
    const onChange = (data) => {
        const reader = new FileReader();
        const loaded = () => {
            changeData(reader.result);
        };
        reader.addEventListener("loadend", loaded);
        reader.readAsText(data.target.files[0]);
    };
    return (React.createElement("div", { className: `focus-editor focus-editor-header` },
        React.createElement("div", null,
            React.createElement(Button, { icon: "floppy-disk", text: "Save", disabled: !props.modified, intent: Intent.SUCCESS, loading: props.saveStatus === ItemStatus.PENDING, minimal: true, onClick: props.saveContent }),
            React.createElement(ButtonWithDialog, { intent: Intent.NONE, form: () => (React.createElement("div", null,
                    React.createElement("p", null, "Please, drop the file you wish to import."),
                    React.createElement("input", { type: "file", onChange: onChange }))), defaultContent: {}, icon: "import", text: "Import", minimal: true, loading: props.importJob === ItemStatus.PENDING, onAccept: () => {
                    props.updateContent(data);
                } })),
        React.createElement(Keys, { importJob: props.importJob, saveContent: props.saveContent })));
};
//# sourceMappingURL=PythonHeader.js.map